import React from 'react';
import PropTypes from 'prop-types';
import { translate as t } from '../../lib/I18n';
import config from '../../config';
import { BaseModal } from '../general/BaseModal';
import GreenPlanetIcon from '../icons/GreenPlanetIcon';
import CarbonFootprintModalInfoSection from './CarbonFootprintModalInfoSection';
import CarbonFootprintModalAlternativeInfoSection from './CarbonFootprintModalAlternativeInfoSection';

const CarbonFootprintModal = ({ toggleModal, carbonCalculationData, ...restProps }) => {
    const { savedCO2e } = carbonCalculationData;

    const modalProps = {
        onClose: toggleModal(false),
        hideContinue: true,
        titleText: 'carbonFootprint.modal.title',
        className: 'carbon-footprint-modal',
        headerClass: "text-left",
        onOpen: toggleModal(true),
        ...restProps,
    };

    const EPACalculationUrl = config.get('EPACalculationUrl') || '';
    const carbonFootprintCalculatorUrl = config.get('carbonFootprintCalculatorUrl') || '';

    return (
        <BaseModal { ...modalProps }>
            <div className='carbon-footprint-modal__saved-msg--container'>
                <div className='carbon-footprint-modal__saved-msg--icon'>
                    <GreenPlanetIcon />
                </div>
                <p className='no-margin'>
                    <strong>{ t('carbonFootprint.saved', { savedCO2e }) }</strong>
                </p>
            </div>
            <p className='carbon-footprint-modal__text--black'>
                { t('carbonFootprint.modal.paragraph1') }
            </p>
            <p className='carbon-footprint-modal__text--black'>
                { t('carbonFootprint.modal.paragraph2') }
            </p>

            <CarbonFootprintModalInfoSection carbonCalculationData={carbonCalculationData} />
            <CarbonFootprintModalAlternativeInfoSection carbonCalculationData={carbonCalculationData} />

            <p className='carbon-footprint-modal__text--black no-margin'>
                <span>{ t('carbonFootprint.modal.paragraph3') }</span>
                <a href={EPACalculationUrl} target="_blank" className='carbon-footprint-modal__link'>
                    { t('carbonFootprint.modal.paragraph3.link') }
                </a>
                <span>{ t('carbonFootprint.modal.paragraph4') }</span>
                <a href={carbonFootprintCalculatorUrl} target="_blank" className='carbon-footprint-modal__link'>
                    { t('carbonFootprint.modal.paragraph4.link') }
                </a>
                <span>{ t('carbonFootprint.modal.paragraph5') }</span>
            </p>
        </BaseModal>
    );
};

CarbonFootprintModal.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    carbonCalculationData: PropTypes.object.isRequired,
    show: PropTypes.bool,
};

CarbonFootprintModal.defaultProps = {
    toggleModal: () => () => {},
    carbonCalculationData: {},
    show: false,
};

export default CarbonFootprintModal;



// WEBPACK FOOTER //
// ./src/components/carbonFootprint/CarbonFootprintModal.js